import _, { isArray } from "lodash";

/**
 * Represents an input tag component.
 * @param {Object} options - The options for the input tag component.
 * @param {Array<string>} options.tags - The initial tags for the component.
 * @param {string} options.filterType - The type of filter to apply.
 * @param {boolean} options.isReadonly - Whether the input is readonly.
 * @returns {Object} - The input tag Alpine component object.
 */
export default (name, options = {
    tags: [],
    filterType: 'none',
    isReadonly: false
}) => ({
    tags: [],
    isFocused: false,
    // TODO: Agregar nueva variable que maneje el estado de READONLY
    disabled: options.isReadonly, // Initialize disabled state based on isReadonly

    init() {
        this.setTags(options.tags);
        this.$watch('tags', value => {
            this.$dispatch('input-tag-change', { value, name });
        });
    },

    setTags(tags) {
        if (!isArray(tags)) throw new Error('The tags must be an array.', tags);
        tags.forEach(tag => {
            if(this.tags.includes(tag)){
                this.$dispatch('add-toast', {
                    type: 'warning',
                    title: 'Etiqueta duplicada',
                    message: `La etiqueta "${tag}" ya se encuentra en la lista.`,
                });

                return;
            }

            this.tags.push(this.formatTag(tag))
        });
    },

    deleteLastTag() {
        if (this.$refs.input.value) return;
        let tags = this.$refs.tags_container.querySelectorAll('span');
        if (tags.length > 0) {
            const lastTag = tags[tags.length - 1];
            this.$refs.input.value = lastTag.textContent;
            lastTag.remove();
            this.tags.pop();
        }
    },

    deleteTag(index) {
        this.tags.splice(index, 1);
    },

    addTag($event) {
        if (this.disabled) return;

        const input = $event.target;
        const val = input.value;

        if (!val) return;

        input.value = '';

        this.tags.push(this.formatTag(val));
    },

    formatTag(tag) {
        switch (options.filterType) {
            case 'uppercase':
                return _.upperCase(tag);
            case 'lowercase':
                return _.lowerCase(tag);
            case 'slug':
                return _.kebabCase(tag);
            case 'hashtag':
                tag = _.camelCase(tag);
                return !tag.startsWith('#') ? `#${tag}` : tag;
            case 'startcase':
                return _.startCase(tag);
            case 'none':
            default:
                return tag;
        }
    },

    setDisabled(value) {
        if (typeof value !== 'boolean') {
            throw new Error('The value must be a boolean. (setDisabled for inputTag)');
        }
        this.disabled = value;
    }
});


